import React from 'react';
import { QrCode, ArrowRight, Check, Smartphone } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import Navbar from '../Navbar';
import Footer from '../Footer';
import { useAuth } from '../../context/AuthContext';

const QRCodesPage = () => {
  const { login } = useAuth();

  const features = [
    'Gere QR Codes personalizados',
    'Direcione para WhatsApp',
    'Rastreamento de scans',
    'Use em materiais impressos',
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-28 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 bg-gray-100 text-gray-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
                <QrCode className="h-4 w-4" />
                QR Codes
              </div>
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                <span className="text-[#3b82f6]">QR Codes</span> para WhatsApp
              </h1>
              <p className="text-xl text-gray-600 mb-8">
                Gere QR Codes que direcionam clientes diretamente para seu chatbot no WhatsApp.
              </p>
              <Button onClick={login} size="lg" className="bg-[#3b82f6] hover:bg-[#2563eb]">
                Começar gratuitamente
              </Button>
            </div>
            <div className="flex justify-center">
              <div className="bg-white rounded-3xl shadow-xl p-8">
                <div className="w-48 h-48 bg-gray-900 rounded-2xl flex items-center justify-center">
                  <QrCode className="h-32 w-32 text-white" />
                </div>
                <p className="text-center mt-4 text-sm text-gray-600">Escaneie para iniciar conversa</p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gray-50 py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Recursos</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {features.map((feature) => (
                <div key={feature} className="bg-white rounded-xl p-6 shadow-sm">
                  <Check className="h-6 w-6 text-green-500 mb-3" />
                  <p className="font-medium text-gray-900">{feature}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <Card className="bg-gradient-to-br from-[#3b82f6] to-[#1d4ed8] text-white">
              <CardContent className="py-12 text-center">
                <h2 className="text-2xl font-bold mb-4">Crie seu QR Code agora</h2>
                <Button onClick={login} variant="secondary" size="lg" className="bg-white text-[#3b82f6] hover:bg-gray-100">
                  Começar agora <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </CardContent>
            </Card>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default QRCodesPage;
